export default "__VITE_ASSET__NMWqZk6R__"